import React, { useState, useEffect, useContext } from 'react';
import { InfiniteScroll, PullToRefresh } from 'antd-mobile';
import styled from 'styled-components';
import { getWorkEntries } from '../api';
import WorkEntriesList from '../components/WorkEntriesList';
import WorkTimeBar from '../components/WorkTimeBar';
import UserSelfContext from '../utils/self-context';
import { serialize } from '../utils/helpers';
import WorkEntryPopup from '../components/WorkEntryPopup';

const WorkEntriesWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const ListWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow:  auto;
	width: 100%;
	background: #f0f2f5;
`;

function WorkEntries() {
	const [loading, setLoading] = useState(false);
	const [err, setErr] = useState(false);
	const [workEntries, setWorkEntries] = useState([]);
	const [hasMore, setHasMore] = useState('');
	const [page, setPage] = useState(1);
	const [selectedRecord, setSelectedRecord] = useState({});
	const [workEntryPopupVisible, setWorkEntryPopupVisible] = useState(false);
	const { userSelf } = useContext(UserSelfContext);


	async function fetchWorkEntries(currentPage, silent, reset) {
		if (!silent) {
			setLoading(true);
		}
		try {
			const data = await getWorkEntries(`?${serialize({
				page: currentPage,
				user_id: userSelf.id
			})}`);
			const newList = reset ? data.items : [...workEntries, ...data.items];
			setHasMore(data.items?.length && newList.length < data.total_count);
			setWorkEntries(newList);
			setPage(currentPage);
		} catch (e) {
			setErr(true);
		}

		setLoading(false);
	}

	useEffect(() => {
		fetchWorkEntries(1, false, true);
	}, [userSelf]);

	useEffect(() => {
		fetchWorkEntries(page);
	}, []);

	function handleWorkEntryChange() {
		setWorkEntryPopupVisible(false);
		fetchWorkEntries(1, false, true);
	}


	async function onLoadMore() {
		const newPage = page + 1;
		await fetchWorkEntries(newPage, true);
	}

	return (
		<WorkEntriesWrapper>
			<WorkTimeBar displayIfNotWorking />
			<ListWrapper>
				<PullToRefresh
					onRefresh={async () => {
						await fetchWorkEntries(1, true, true);
					}}
				>
					<WorkEntriesList
						onWorkEntryClick={(we) => {
							setSelectedRecord(we);
							setWorkEntryPopupVisible(true);
						}}
						loading={loading}
						workEntries={workEntries}
					/>
					{(!loading && hasMore) ? <InfiniteScroll loadMore={onLoadMore} hasMore={hasMore && !loading} /> : null}
				</PullToRefresh>
			</ListWrapper>
			<WorkEntryPopup
				workEntry={{
					...selectedRecord
				}}
				visible={workEntryPopupVisible}
				onClose={() => {
					setWorkEntryPopupVisible(false);
					setSelectedRecord({});
				}}
				onSubmit={handleWorkEntryChange}
			/>
		</WorkEntriesWrapper>
	);
}

export default WorkEntries;
